import { render, staticRenderFns } from "./ReservationsDetail.vue?vue&type=template&id=0594627f&"
import script from "./ReservationsDetail.vue?vue&type=script&lang=js&"
export * from "./ReservationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports